/**
 * Enum Prompt Engine — PRD §10.2 (modes), §12 (presets), §30 (provider modality).
 */

export const PROMPT_MODE = [
  'initial', // versi pertama saat prompt package dibuat, bukan hasil transform mode manapun
  'clarify',
  'polish',
  'expand',
  'condense',
  'reformat',
  'adapt',
] as const;
export type PromptMode = (typeof PROMPT_MODE)[number];

/** MVP presets — PRD §12. Phase berikutnya (Luxury, Fashion, dst.) sengaja tidak dimasukkan di sini. */
export const PROMPT_PRESET_KEY = [
  'tiktok_ugc',
  'product_showcase',
  'problem_solution',
  'cinematic_product',
  'direct_response',
] as const;
export type PromptPresetKey = (typeof PROMPT_PRESET_KEY)[number];

export const PROVIDER_MODALITY = ['llm', 'image', 'video', 'voice'] as const;
export type ProviderModality = (typeof PROVIDER_MODALITY)[number];

/**
 * PRD §16: LLMProvider/ImageProvider/VoiceProvider adapter tunggal untuk MVP; VideoProvider = pool.
 * 'gemini' dipertahankan untuk backward compat — rows lama di DB prompt_versions
 * sudah tercatat dengan provider='gemini' sebelum migrasi ke Cloudflare AI Workers.
 * Provider aktif sekarang: 'cloudflare' (CloudflareAiLlmProvider).
 */
export const LLM_PROVIDER_NAME = ['cloudflare', 'gemini'] as const;
export type LlmProviderName = (typeof LLM_PROVIDER_NAME)[number];
